import { Overlay } from "@angular/cdk/overlay";
import { DOCUMENT } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  NgZone,
  Optional,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzMentionComponent } from "ng-zorro-antd/mention";
import { UiMentionSuggestionDirective } from "./directives/mention-suggestions";
import { UiMentionOnSearchTypes, UiMentionPlacement } from "./mention.models";
import { UiMentionService } from "./services/mention.service";

@Component({
  selector: "ui-mention",
  exportAs: "uiMention",
  templateUrl: "./mention.component.html",
  providers: [UiMentionService],
})
export class UiMentionComponent extends NzMentionComponent {
  @Input("uiValueWith") public nzValueWith: (value: NzSafeAny) => string = (value) => value;
  @Input("uiPrefix") public nzPrefix: string | string[] = "@";
  @Input("uiLoading") @InputBoolean() public nzLoading = false;
  @Input("uiNotFoundContent") public nzNotFoundContent = "No matching results, tap the space to complete the input";
  @Input("uiPlacement") public nzPlacement: UiMentionPlacement = "bottom";
  @Input("uiSuggestions") public nzSuggestions: NzSafeAny[] = [];
  @Output("uiOnSelect") public readonly nzOnSelect: EventEmitter<NzSafeAny> = new EventEmitter();
  @Output("uiOnSearchChange") public readonly nzOnSearchChange: EventEmitter<UiMentionOnSearchTypes> = new EventEmitter();

  @ViewChild(TemplateRef, { static: false }) public suggestionsTemp?: TemplateRef<void>;
  @ViewChildren("items", { read: ElementRef })
  public items!: QueryList<ElementRef>;
  @ContentChild(UiMentionSuggestionDirective, { static: false, read: TemplateRef })
  set suggestionChild(value: TemplateRef<{ $implicit: NzSafeAny }>) {
    if (value) {
      this.suggestionTemplate = value;
    }
  }

  constructor(
    ngZone: NgZone,
    @Optional() @Inject(DOCUMENT) ngDocument: NzSafeAny,
    cdr: ChangeDetectorRef,
    overlay: Overlay,
    viewContainerRef: ViewContainerRef,
    uiMentionService: UiMentionService
  ) {
    super(ngZone, ngDocument, cdr, overlay, viewContainerRef, uiMentionService);
  }
}
